export function getUrlParameter(_param) {
  const name = _param.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]'); // eslint-disable-line no-useless-escape
  const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  const results = regex.exec(window.location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

export function isAbsoluteUrl(url) {
  var pattern = /^((http|https):\/\/)/;
  return pattern.test(url);
}